<template lang="pug">
v-content
  v-container.fill-height(fluid)
    v-row(align="center", justify="center")
      v-col(cols="12", sm="10")
        v-card.elevation-12
          v-toolbar(color="primary", dark, flat)
            v-toolbar-title Correos en Masivo
          v-card-text
            ValidationObserver(
              ref="observer_send_email",
              v-slot="{ validate, reset }"
            )
              v-form
                ValidationProvider(
                  v-slot="{ errors }",
                  name="Titulo",
                  rules="required"
                )
                  v-text-field(
                    label="Titulo",
                    type="text",
                    v-model="subject",
                    :error-messages="errors",
                    outlined,
                    required
                  )
                v-row
                  v-col(cols="12", sm="10")
                    ValidationProvider(
                      v-if="admin",
                      v-slot="{ errors }",
                      name="Correos Veterinarios",
                      :rules="admin ? (all_vets ? '' : 'required') : ''"
                    )
                      v-autocomplete(
                        chips,
                        outlined,
                        multiple,
                        clearable,
                        persistent-hint,
                        v-model="email_vet",
                        :items="emails_vet",
                        :disabled="all_vets",
                        :required="!all_vets",
                        item-text="email",
                        item-value="email",
                        :error-messages="errors",
                        label="Correos Veterinarios"
                      )
                  v-col(cols="12", sm="2")
                    v-switch(
                      v-if="admin",
                      color="secondary",
                      v-model="all_vets",
                      @change="getEmailsVet",
                      label="Todos los veterinarios"
                    )
                v-row
                  v-col(cols="12", sm="10")
                    ValidationProvider(
                      v-slot="{ errors }",
                      name="Correos Propietarios",
                      :rules="all_owners ? '' : 'required'"
                    )
                      v-autocomplete(
                        :items="emails_owners",
                        chips,
                        outlined,
                        multiple,
                        clearable,
                        persistent-hint,
                        v-model="email_owner",
                        item-value="email",
                        item-text="email",
                        :disabled="all_owners",
                        :required="!all_owners",
                        :error-messages="errors",
                        label="Correos Propietarios"
                      )
                  v-col(cols="12", sm="2")
                    v-switch(
                      color="secondary",
                      v-model="all_owners",
                      @change="getEmailsOwner",
                      label="Todos los propietarios"
                    )
              vue-editor(v-model="content")
            v-card-actions
              v-spacer
              v-btn(color="success", @click="sendEmail") Enviar
</template>

<script>
import userAPI from "@/api/user";
import { required } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    admin: {
      type: Boolean,
      default: true,
    },
    emails_vet: {
      type: Array,
      required,
    },
    emails_owners: {
      type: Array,
      required,
    },
    auth_token: {
      type: String,
      default: "",
      required,
    },
  },
  data() {
    return {
      content: null,
      subject: null,
      email_vet: [],
      email_owner: [],
      all_vets: false,
      all_owners: false,
    };
  },
  methods: {
    async sendEmail() {
      if (await this.$refs.observer_send_email.validate()) {
        if (this.content) {
          const response = await userAPI.sendEmail(this.auth_token, {
            vets: this.email_vet,
            subject: this.subject,
            content: this.content,
            owners: this.email_owner,
          });
          this.$swal({
            title: response.status
              ? `${response.data.emails}`
              : `${response.data}`,
            icon: response.status ? "success" : "error",
          });
        } else {
          this.$swal({
            title: "Correo Electrónico Vácio",
            icon: "warning",
          });
        }
      }
    },
    getEmailsVet() {
      if (this.all_vets) {
        for (let index in this.emails_vet)
          this.email_vet.push(this.emails_vet[index].email);
      } else {
        this.email_vet = [];
      }
    },
    getEmailsOwner() {
      if (this.all_owners) {
        for (let index in this.emails_owners)
          this.email_owner.push(this.emails_owners[index].email);
      } else {
        this.email_owner = [];
      }
    },
  },
};
</script>
